"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'step.delete.confirm.title': 'Delete Step',
    'step.delete.confirm.message': 'Are you sure you want to delete this step?',
};
